import { IAuthConfig } from '@forge/sso-client';
import { forgeIAMAPI, forgeIAMClientId } from './utils/properties/UrlsAndEnvProperties';

export const authConfig: IAuthConfig = {
  authority: forgeIAMAPI(),
  
  client_id: forgeIAMClientId(),
 
  response_type: 'code',
  scope: 'openid offline groups email customersub',
  
  redirect_uri: `${window.location.origin}/callback`,
  extraQueryParams: { customer_hint: 'honeywell' },
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  automaticSilentRenew: true,
};

 